export const NAV_KEYS = {
  USER_LIBRARY: 'USER_LIBRARY',
  ANALYTICS_SUITE: 'ANALYTICS_SUITE'
};
export const SMART_LIBRARY_PATHS = {
  [NAV_KEYS.USER_LIBRARY]: '/',
  [NAV_KEYS.ANALYTICS_SUITE]: '/collections'
};
export const ANALYTICS_SUITE_TAB_IDS = {
  DISCOVER: 'discover',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  COMMERCE: 'commerce'
};